<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="(date | titlecase) + (local ? ' | ' + local : '')"
  (click)="onClickWidget()"
>

  <app-widget-principal-data
    label="%"
    progressColor="#ff18af"
    [data]="widgetData"
    [progress]="widgetData / 100"
    [showData]="loadedData || isStoreView"
  ></app-widget-principal-data>

</app-widget-home-core>
